/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TerminiBozzaDTO { 
    testo_it?: string;
    testo_en?: string;
    updated_at?: string;
    version?: number;
}

